module.exports = __webpack_public_path__ + "img/monnezza-left-bottom.455dd792.png";